<template>
  <q-card flat>
    <q-card-section class="no-padding fixed-header-position">
      <q-banner class="bg-primary text-white fixed z-marginals full-width">
        گزارش مانده سفارش
      </q-banner>
      <q-card-section align="center" style="top: 50px" class="bg-white">
        <q-chip square size="lg"  color="indigo" text-color="white" label="جمع کل مانده سفارش تا کنون">
          <q-chip square size="md" class="q-ml-md" color="red" text-color="white"
                  :label="lodash.sumBy(items, item=> item.TotalG_Count)"/>
        </q-chip>
        <q-chip size="lg" label="قیمت کل" color="indigo" text-color="white" square>
          <q-chip square size="md"
                  :label="lodash.sumBy(items, item=> item.SaleG_PricePure).toLocaleString()" color="red"
                  text-color="white"/>
        </q-chip>
        <vue-json-to-csv
            :json-data="items" v-if="items && items.length>0">
          <q-btn round color="indigo" text-color="white" icon="download">
            <q-tooltip>
              دانلود گزارش
            </q-tooltip>
          </q-btn>
        </vue-json-to-csv>
        <q-input :dense="$q.screen.lt.md" filled type="text" label="جستجو..."
                 v-model="filter"/>

      </q-card-section>
    </q-card-section>
    <q-card-section style="top: 20px">
    </q-card-section>
    <q-card-section>
      <q-table
          style="top:50px"
          :data="items"
          row-key="Goods_ID"
          wrap-cells
          flat
          :rows-per-page-options="[0]"
          :filter="filter">
        <template v-slot:header>

          <q-tr>
            <q-td class="text-subtitle2">
              عنوان کالا
            </q-td>
            <q-td class="text-subtitle2 text-center">
              تعداد
            </q-td>
            <q-td class="text-subtitle2 text-center">
              مبلغ
            </q-td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class" v-if="props.row.SaleG_PricePure>0">
            <q-td>
              {{ props.row.Goods_Name }}
              <q-badge color="red" align="top" text-color="white" :label="props.row.Goods_Code"/>
            </q-td>
            <td class="text-center">
              <q-chip clickable square :size="$q.screen.lt.md?'sm':'md'" color="indigo-14" text-color="white"
                      :label="props.row.TotalG_Count" @click="showGoodsDetails(props.row)" />
            </td>
            <td class="text-center">
              <q-chip clickable square :size="$q.screen.lt.md?'sm':'md'" color="red-14" text-color="white"
                      :label="props.row.SaleG_PricePure.toLocaleString()" />
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog v-model="detailDialog" :maximized="$q.screen.lt.md">
      <RemainOrdersDetail :goods-info="selectedGoods"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import RemainOrdersDetail from "@/components/orders/RemainOrdersDetail";
import VueJsonToCsv from 'vue-json-to-csv'


export default {
  name: "RemainOrder",
  components: {RemainOrdersDetail, VueJsonToCsv},
  data() {
    return {
      selectedGoods: '',
      detailDialog: false,
      items: [],
      filter: ''
    }
  },
  methods: {
    ...mapActions({
      getRemainOrders: 'Orders/getRemainOrders'
    }),
    showGoodsDetails(row) {
      this.selectedGoods = row;
      this.detailDialog = true;
    },
    setRemainOrders() {
      this.getRemainOrders().then((res) => {
        this.items = res
      });
    }
  },
  created() {
    this.setRemainOrders();
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000;
}
</style>